/**
 * @generated SignedSource<<9f1eb4f3454ea49977fbe6f70bc1927c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteNotificationIntegrationInput = {
  id: any;
};
export type DiscordIntegrationDeleteNotificationIntegrationMutation$variables = {
  input: DeleteNotificationIntegrationInput;
};
export type DiscordIntegrationDeleteNotificationIntegrationMutation$data = {
  readonly deleteNotificationIntegration: {
    readonly error: string | null | undefined;
    readonly success: boolean;
  };
};
export type DiscordIntegrationDeleteNotificationIntegrationMutation = {
  response: DiscordIntegrationDeleteNotificationIntegrationMutation$data;
  variables: DiscordIntegrationDeleteNotificationIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteNotificationIntegrationPayload",
    "kind": "LinkedField",
    "name": "deleteNotificationIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DiscordIntegrationDeleteNotificationIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DiscordIntegrationDeleteNotificationIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "88d688a60cc98b079ecc7c3b9471ee3d",
    "id": null,
    "metadata": {},
    "name": "DiscordIntegrationDeleteNotificationIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation DiscordIntegrationDeleteNotificationIntegrationMutation(\n  $input: DeleteNotificationIntegrationInput!\n) {\n  deleteNotificationIntegration(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "cd434cac1582961e0df639c46025e17a";

export default node;
